import { resolveDiPdfFilename } from 'service/DiIdentity';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Chip, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import SendIcon from "@mui/icons-material/Send";

import { DropzoneAreaBase } from "material-ui-dropzone";
import { PictureAsPdf } from "@material-ui/icons";
import AudioRecorder from "components/utils/AudioRecorder";
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from "reducers/loadingSlice";
import { ENDPOINT } from "constants/variables";
import image1 from "components/photos/sidebars/takephoto.jpeg";
import ReportTemplateFirst from "pages/forms/formDICreateInicident/ReportTemplateFirst";
import ReportTemplateSecond from "pages/forms/formDICreateInicident/ReportTemplateSecond";
import { addFormDIDecaQrToPdf, fetchFormDIDecaQr } from 'pages/forms/pdf/formDIDecaQr';
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/formDIIncidentResponsive.css";

const INITIAL_DATA_FORM = Object.freeze({
  id: 0,
  ownformdi_id: 0,
  defaultStore_id: 0,
  useraccount_id: 0,
  defaultformatnumber: 1,
  isFinished: true,
  isScanned: false,
  numberDI_sheet: "",
  date_sheet: "",

  opt_tras_documnettype: "",
  opt_tras_documentid: "",
  opt_tras_name: "",
  opt_tras_contactname: "",
  opt_tras_cnae: "",
  opt_tras_nima: "",
  opt_tras_country: "",
  opt_tras_province: "",
  opt_tras_locality: "",
  opt_tras_community: "",
  opt_tras_phone: "",
  opt_tras_licenseplate: "",
  opt_tras_economicactivity: "",
  opt_tras_tradename: "",
  opt_tras_street: "",
  opt_tras_postalcode: "",
  opt_tras_email: "",
  opt_tras_inscription: "",
  opt_tras_opt: "",

  ori_tras_documnettype: "",
  ori_tras_documentid: "",
  ori_tras_name: "",
  ori_tras_contactname: "",
  ori_tras_cnae: "",
  ori_tras_nima: "",
  ori_tras_country: "",
  ori_tras_province: "",
  ori_tras_locality: "",
  ori_tras_community: "",
  ori_tras_phone: "",
  ori_tras_licenseplate: "",
  ori_tras_economicactivity: "",
  ori_tras_tradename: "",
  ori_tras_street: "",
  ori_tras_postalcode: "",
  ori_tras_email: "",
  ori_tras_inscription: "",
  ori_tras_opt: "",

  aut_tras_documnettype: "",
  aut_tras_documentid: "",
  aut_tras_name: "",
  aut_tras_contactname: "",
  aut_tras_cnae: "",
  aut_tras_nima: "",
  aut_tras_country: "",
  aut_tras_province: "",
  aut_tras_locality: "",
  aut_tras_community: "",
  aut_tras_phone: "",
  aut_tras_licenseplate: "",
  aut_tras_economicactivity: "",
  aut_tras_tradename: "",
  aut_tras_street: "",
  aut_tras_postalcode: "",
  aut_tras_email: "",
  aut_tras_inscription: "",
  aut_tras_opt: "",

  dest_tras_documnettype: "",
  dest_tras_documentid: "",
  dest_tras_name: "",
  dest_tras_contactname: "",
  dest_tras_cnae: "",
  dest_tras_nima: "",
  dest_tras_country: "",
  dest_tras_province: "",
  dest_tras_locality: "",
  dest_tras_community: "",
  dest_tras_phone: "",
  dest_tras_licenseplate: "",
  dest_tras_economicactivity: "",
  dest_tras_tradename: "",
  dest_tras_street: "",
  dest_tras_postalcode: "",
  dest_tras_email: "",
  dest_tras_inscription: "",
  dest_tras_opt: "",

  aut_dest_documnettype: "",
  aut_dest_documentid: "",
  aut_dest_name: "",
  aut_dest_contactname: "",
  aut_dest_cnae: "",
  aut_dest_nima: "",
  aut_dest_country: "",
  aut_dest_province: "",
  aut_dest_locality: "",
  aut_dest_community: "",
  aut_dest_phone: "",
  aut_dest_licenseplate: "",
  aut_dest_economicactivity: "",
  aut_dest_tradename: "",
  aut_dest_street: "",
  aut_dest_postalcode: "",
  aut_dest_email: "",
  aut_dest_inscription: "",
  aut_dest_opt: "",

  rel_trans_documnettype: "",
  rel_trans_documentid: "",
  rel_trans_name: "",
  rel_trans_contactname: "",
  rel_trans_cnae: "",
  rel_trans_nima: "",
  rel_trans_country: "",
  rel_trans_province: "",
  rel_trans_locality: "",
  rel_trans_community: "",
  rel_trans_phone: "",
  rel_trans_licenseplate: "",
  rel_trans_economicactivity: "",
  rel_trans_tradename: "",
  rel_trans_street: "",
  rel_trans_postalcode: "",
  rel_trans_email: "",
  rel_trans_inscription: "",
  rel_trans_opt: "",

  resp_prod_documnettype: "",
  resp_prod_documentid: "",
  resp_prod_name: "",
  resp_prod_contactname: "",
  resp_prod_cnae: "",
  resp_prod_nima: "",
  resp_prod_country: "",
  resp_prod_province: "",
  resp_prod_locality: "",
  resp_prod_community: "",
  resp_prod_phone: "",
  resp_prod_licenseplate: "",
  resp_prod_economicactivity: "",
  resp_prod_tradename: "",
  resp_prod_street: "",
  resp_prod_postalcode: "",
  resp_prod_email: "",
  resp_prod_inscription: "",
  resp_prod_opt: "",

  codeLER: "",
  codeLER_code: "",
  codeLER_name: "",
  description: "",
  description_code: "",
  description_name: "",
  treatmenttypeorigin_code: "",
  treatmenttypeorigin_name: "",
  treatmenttypedestine_code: "",
  treatmenttypedestine_name: "",
  processtypepeorigin_code: "",
  processtypepeorigin_name: "",
  processtypedestine_code: "",
  processtypedestine_name: "",
  dangerousness_name: "",
  charac_danger: "",
  amount: "",
  deliver_date: "",
  delivery_quantity: "",
  date_accepted: "",
  accept: "",
  date_refund: "",
  reason_refund: "",
  action_refund: "",
  observations1: "",
  observations2: "",

  signature_opt_tras: "",
  signature_dest_tras: "",
  signature_refund: "",
  end_date_sheet: "",
  widevalidity: false,
});

const INITIAL_EMAIL = Object.freeze({
  id: "",
  defaultStore_id: 0,
  tradename: "",
  useraccount_id: 0,
  username: "",
  createdate: null,
  emailto: "gestrescan@gmail.com",
  subjectEmail: "",
  contentEmail: "",
  resolution: "",
  slatype_id: 0,
  slatype_namees: "",
  slatype_nameen: "",
  incidenttype_id: 1,
  incidenttype_namees: "",
  incidenttype_nameen: "",
  resolution_id: 0,
  resolution_namees: "",
  resolution_nameen: "",
  formdi_id: 0,
  ownformdi_id: "",
  numberDI_sheet: "",
  purchase_id: "",
  ownpurchase_id: "",
  isfinished: false,
  hasbeenread: false,
  updatedFiles: [],
});
 
const INITIAL_TYPES = Object.freeze([{ id: "", code: "", namees: "", nameen: "" }]);
const INITIAL_DEFAULT_TYPE = Object.freeze({ id: "1", code: "", namees: "", nameen: "" });
const INITIAL_EMAIL_LIST = Object.freeze([{ id: "", email: "" }]);

/* ------------------------------ HELPERS ------------------------------ */
function useDebouncedCallback(callback, delay = 300) {
  const timeoutRef = useRef(null);

  return useCallback(
    (...args) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => callback(...args), delay);
    },
    [callback, delay]
  );
}

function useObjectUrl(blob) {
  const url = useMemo(() => {
    if (!blob) return "";
    return URL.createObjectURL(blob);
  }, [blob]);

  useEffect(() => {
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [url]);

  return url;
}

function splitFileBase64(dataUrl) {
  if (!dataUrl || typeof dataUrl !== "string") return "";
  const parts = dataUrl.split(",");
  return parts[1] || "";
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = String(reader.result || "").split(",")[1] || "";
      resolve(base64);
    };
    reader.onerror = reject;
  });
}

/* ------------------------------ UI PARTS ----------------------------- */

function EmailHeader({ t, onSend, onClose }) {
  return (
    <Box className="email-card-header" sx={{ width: "100%", boxSizing: "border-box", p: { xs: 1.5, sm: 2 } }}>
      <Box className="formdi-incident-header-row" sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#4e73df", fontSize: { xs: 20, sm: 24 }, lineHeight: 1.3, minWidth: 0 }}>
          <i className="fas fa-envelope" />
          <span style={{ overflowWrap: "anywhere", minWidth: 0 }}>{t("Text_SENDEMAIL_Title")}</span>
        </Box>
        <Box className="formdi-incident-header-actions" sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 1,
          "& > button": { width: "100% !important", minWidth: "0 !important", m: "0 !important", height: "44px !important", minHeight: "44px !important", p: "8px !important", fontSize: "15px !important", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", boxSizing: "border-box" } }}>
          <button type="button" className="email-send-btn" onClick={onSend}>
            {t("Text_Send").toUpperCase()}<SendIcon sx={{ fontSize: 20, color: "white" }} />
          </button>
          <button type="button" className="email-cancel-btn" onClick={onClose}>{t("Menu_LogOut")}</button>
        </Box>
      </Box>
    </Box>
  );
}

function PreviewModal({ t, previewImage, onClose }) {
  if (!previewImage) return null;
  return (
    <div className="preview-modal-overlay">
      <div className="preview-modal-content">
        <button type="button" onClick={onClose} className="preview-close-button" title={t("Text_Close")}>
          &times;
        </button>
        <img src={previewImage} alt={t("Text_View_Great")} className="preview-image" />
      </div>
    </div>
  );
}

function CameraModal({ t, open, videoRef, canvasRef, onCapture, onCancel }) {
  if (!open) return null;
  return (
    <div className="camera-modal-overlay">
      <div className="camera-modal-content">
        <video ref={videoRef} autoPlay playsInline width="320" height="240" className="camera-video" />
        <canvas ref={canvasRef} style={{ display: "none" }} />
        <div className="camera-buttons">
          <button className="btn btn-success" onClick={onCapture}>
            📸 {t("Button_Capture")}
          </button>
          <button className="btn btn-danger" onClick={onCancel}>
            ❌ {t("Button_Cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

const SendEMAILFormDIToSystem = ({ id, showModalSentInicidents,typeOfList} ) => {
  const { t, i18n } = useTranslation(["listDataGeneralSettings"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.loginUser.token);
  const roles = useSelector((state) => state.loginUser.roles);
  const defaultStore_id = useSelector((state) => state.loginUser.defaultStore.id);
  const defaultStore_username = useSelector((state) => state.loginUser.defaultStore.tradename);
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);
  const useraccount_username = useSelector((state) => state.loginUser.username);
  const footeremail = useSelector((state) => state.loginUser.defaultticketsformat.footeremail);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);
  const sendbyemail_form_opt_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_opt_tras);
  const sendbyemail_form_ori_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_ori_tras);
  const sendbyemail_form_aut_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_aut_tras);
  const sendbyemail_form_aut_dest = useSelector((state) => state.formatDIUser.sendbyemail_form_aut_dest);
  const sendbyemail_form_dest_tras = useSelector((state) => state.formatDIUser.sendbyemail_form_dest_tras);
  const sendbyemail_form_rel_trans = useSelector((state) => state.formatDIUser.sendbyemail_form_rel_trans);
  const sendbyemail_form_resp_prod = useSelector((state) => state.formatDIUser.sendbyemail_form_resp_prod);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [dataForm, setDataForm] = useState(() => INITIAL_DATA_FORM);
  const [formEMAIL, setFormEMAIL] = useState(() => INITIAL_EMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [incidenteTypeToSelect, setIncidenteTypeToSelect] = useState(() => INITIAL_TYPES);
  const [defaultIncidenteType, setDefaultIncidenteType] = useState(() => INITIAL_DEFAULT_TYPE);
  const [emailToSelect, setEmailToSelect] = useState(() => INITIAL_EMAIL_LIST);
  const [filteredEmail, setFilteredEmail] = useState([]);
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1);
  const [files, setFiles] = useState([]);
  const [filesImages, setFilesImages] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pendingSend, setPendingSend] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const pdfBlobUrl = useObjectUrl(pdfBlob);
  
  const pdfViewer = useMemo(() => {
    const src = pdfUrl || pdfBlobUrl;
    if (!src) return null;
    return <iframe src={`${src}#view=FitH`} title="PDF Preview" style={{ width: "100%", height: "100%", border: "none" }} />;
  }, [pdfUrl, pdfBlobUrl]);

  const shouldGeneratePdf = useMemo(() => {
    return !pdfUrl && !isLoadingData && dataForm.id !== 0;
  }, [pdfUrl, isLoadingData, dataForm.id]);

  /* ------------------------------ Actions ------------------------------ */

  const resetAll = useCallback(() => {
    setDataForm(INITIAL_DATA_FORM);
    setFormEMAIL(INITIAL_EMAIL);
    setErrorsEMAIL({});
    setIncidenteTypeToSelect(INITIAL_TYPES);
    setDefaultIncidenteType(INITIAL_DEFAULT_TYPE);
    setEmailToSelect(INITIAL_EMAIL_LIST);
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
    setFiles([]);
    setFilesImages([]);
    setPreviewImage(null);
    setPdfBlob(null);
    setPdfUrl("");
    setPendingSend(false);
    dispatch(setLoading(false));
  }, [dispatch]);

  const stopCameraStream = useCallback(() => {
    const video = videoRef.current;
    if (video?.srcObject) {
      video.srcObject.getTracks().forEach((track) => track.stop());
    }
  }, []);

  const closeModal = useCallback(() => {
    if (showCameraModal) {
      stopCameraStream();
      setShowCameraModal(false);
      return;
    }
    resetAll();
    navigate(typeOfList === "1" ? "/formdi" : "/formdiended");
  }, [navigate, resetAll, showCameraModal, stopCameraStream, typeOfList]);

  /* ------------------------------ Validation ------------------------------ */

  const validateFormEmail = useCallback(() => {
    const errs = {};
    const regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (!formEMAIL.emailto || formEMAIL.emailto === "") {
      errs.emailto = "Text_FieldSendEmailToRequired";
    } else if (regexInvalidCharacters.test(formEMAIL.emailto)) {
      errs.emailto = "Text_TextNoValid";
    }

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail || "")) {
      errs.subjectEmail = "Text_TextNoValid";
    }

    if (regexInvalidCharacters.test(formEMAIL.contentEmail || "")) {
      errs.contentEmail = "Text_TextNoValid";
    }

    if (!formEMAIL.contentEmail) {
      errs.contentEmail = "Text_SENDEMAIL_ContentEmail_Required";
    }

    return errs;
  }, [formEMAIL]);

  /* ------------------------------ Email autocomplete ------------------------------ */

  const debouncedSearchEmail = useDebouncedCallback(
    (value) => {
      const q = String(value || "").toLowerCase().trim();
      if (!q) {
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);
        return;
      }

      const filtered = (emailToSelect || [])
        .filter((x) => x?.email)
        .filter((x) => x.email.toLowerCase().includes(q))
        .slice(0, 20);

      setFilteredEmail(filtered);
      setHighlightedIndexEmail(filtered.length ? 0 : -1);
    },
    300
  );

  const scrollToElement = useCallback((index) => {
    const dropdown = document.querySelector(".dropdown-class") || document.querySelector(".inicidents-suggest-dropdown");
    const item = dropdown?.children?.[index];
    if (item?.scrollIntoView) {
      item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  const handleSelectEmail = useCallback((emailObj) => {
    if (!emailObj) return;
    setFormEMAIL((prev) => ({ ...prev, emailto: emailObj.email || "" }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }, []);

  const handleKeyDownEmail = useCallback(
    (event) => {
      if (event.key === "ArrowDown") {
        if (filteredEmail.length === 0 && (formEMAIL.emailto || "").trim() === "") {
          setFilteredEmail(emailToSelect);
          setHighlightedIndexEmail(0);
        } else {
          setHighlightedIndexEmail((prev) => {
            const next = prev < filteredEmail.length - 1 ? prev + 1 : prev;
            scrollToElement(next);
            return next;
          });
        }
      } else if (event.key === "ArrowUp") {
        setHighlightedIndexEmail((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToElement(next);
          return next;
        });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
        if (highlightedIndexEmail < filteredEmail.length) {
          handleSelectEmail(filteredEmail[highlightedIndexEmail]);
        }
      } else if (event.key === "Escape") {
        const isValid = (emailToSelect || []).some((x) => (x?.email || "").toLowerCase() === (formEMAIL.emailto || "").toLowerCase());
        if (!isValid) setFormEMAIL((prev) => ({ ...prev, emailto: "" }));
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);
      }
    },
    [
      emailToSelect,
      filteredEmail,
      formEMAIL.emailto,
      handleSelectEmail,
      highlightedIndexEmail,
      scrollToElement,
    ]
  );

  /* ------------------------------ Files ------------------------------ */

  const handleAddFileContract = useCallback(
    (newFiles) => {
      const incoming = (newFiles || []).filter((f) => !files.find((x) => x.data === f.data));
      setFiles((prev) => [...prev, ...incoming]);
    },
    [files]
  );

  const handleDeleteFileContract = useCallback((deleted) => {
    setFiles((prev) => prev.filter((f) => f !== deleted));
  }, []);

  const handleAddImage = useCallback(
    (newFiles) => {
      const incoming = (newFiles || []).filter((file) => !filesImages.find((f) => f.data === file.data));
      setFilesImages((prev) => [...prev, ...incoming]);
    },
    [filesImages]
  );

  const handleDeleteImage = useCallback((deleted) => {
    setFilesImages((prev) => prev.filter((f) => f !== deleted));
  }, []);

  const buildUpdatedFiles = useCallback(async () => {
    const updated = await Promise.all(
      (files || []).map(async (item, index) => {
        const file = item?.file || item;
        const base64 = await toBase64(file);
        return {
          id: index,
          incidents_id: null,
          pathdocument: null,
          relativepathdocument: null,
          filename: file.name,
          createdate: file.lastModified,
          datafile: base64,
          type: file.type,
          sourcepath: null,
        };
      })
    );
    return updated;
  }, [files]);

  const buildUpdatedFilesImages = useCallback(async () => {
    const updated = await Promise.all(
      (filesImages || []).map(async (file, index) => ({
        id: null,
        incidents_id: null,
        pathdocument: null,
        relativepathdocument: null,
        filename: file?.file?.name || `image_${index + 1}.jpg`,
        createdate: new Date(),
        datafile: splitFileBase64(file?.data),
        type: file?.file?.type || "image/jpeg",
        sourcepath: null,
      }))
    );
    return updated;
  }, [filesImages]);

  /* ------------------------------ Preview icon (dropzone) ------------------------------ */

  const handlePreviewIcon = useCallback((fileObject) => {
    const type = fileObject?.file?.type || "";

    if (type.startsWith("audio/")) return null;

    return (
      <Box sx={{ bgcolor: "#00000", width: 200, height: 150, padding: "4px" }}>
        <PictureAsPdf style={{ color: "#e74a3b", width: 50, height: 50 }} />
        <br />
        <br />
        <Chip
          value={fileObject.file.name}
          label={fileObject.file.name}
          clickable={false}
          style={{ color: "#e74a3b", fontSize: 8 }}
        />
      </Box>
    );
  }, []);

  /* ------------------------------ Fetch: incident types ------------------------------ */
  useEffect(() => {
    if (!showModalSentInicidents) return;
    let active = true;
    const fetchIncidentTypes = async () => {
      try {
        const data = await helpHttp().get(ENDPOINT, `incidenttype/incidenttypesorderbynamees`, token);
        if (!active) return;
        if (data?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          return;
        }
        setIncidenteTypeToSelect(data || INITIAL_TYPES);
        const defaultOption = (data || []).find((opt) => String(opt?.code) === "F1") || (data || [])[0];
        if (defaultOption) {
          setDefaultIncidenteType({
            id: defaultOption.id,
            code: defaultOption.code,
            namees: defaultOption.namees,
            nameen: defaultOption.nameen,
          });
        }
      } catch {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    fetchIncidentTypes();
    return () => {
      active = false;
    };
  }, [showModalSentInicidents, token, dispatch, t]);

  /* ------------------------------ Fetch: formDI + pdf ------------------------------ */
  useEffect(() => {
    if (!showModalSentInicidents) return;
    let active = true;
    const fetchFileFromS3 = async (fileName, decaQrDataUrl = '') => {
      try {
        const blob = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token, fileName);
        if (!active) return;

        if (!blob) {
          setPdfUrl("");
          dispatch(warningErrorAction(t("Text_ConnectionFailed")));
          return;
        }

        if (blob.size > 0) {
          const pdfWithQr = await addFormDIDecaQrToPdf(blob, decaQrDataUrl);
          const url = URL.createObjectURL(pdfWithQr);
          setPdfUrl(url);

          const file = new File([pdfWithQr], fileName, { type: "application/pdf" });
          setFiles((prev) => {
            const safePrev = Array.isArray(prev) ? prev : [];
            const exists = safePrev.some((fo) => (fo?.file || fo)?.name === fileName);
            return exists ? safePrev : [...safePrev, { file }];
          });
        }
      } catch {
        setPdfUrl("");
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    const fillEmailFromForm = (getData) => {
      const emails = [
        sendbyemail_form_opt_tras ? getData?.opt_tras_email : "",
        sendbyemail_form_ori_tras ? getData?.ori_tras_email : "",
        sendbyemail_form_aut_tras ? getData?.aut_tras_email : "",
        sendbyemail_form_aut_dest ? getData?.aut_dest_email : "",
        sendbyemail_form_dest_tras ? getData?.dest_tras_email : "",
        sendbyemail_form_rel_trans ? getData?.rel_trans_email : "",
        sendbyemail_form_resp_prod ? getData?.resp_prod_email : "",
      ]
        .filter((e) => e && String(e).trim() !== "")
        .map((e) => String(e).trim().toLowerCase());

      const emailto = [...new Set(emails)].join(";");

      setFormEMAIL((prev) => ({
        ...prev,
        defaultStore_id,
        useraccount_id,
        emailto,
        incidenttype_id: defaultIncidenteType.id,
        incidenttype_namees: defaultIncidenteType.namees,
        incidenttype_nameen: defaultIncidenteType.nameen,
        formdi_id: id,
        ownformdi_id: getData?.ownformdi_id,
        numberDI_sheet: getData?.numberDI_sheet,
        subjectEmail: `LE REMITO LA INCIDENCIA CON FORMULARIO D.I. Nº: ${getData?.numberDI_sheet || ""}`,
        contentEmail: footeremail,
      }));
    };

    const fetchFormDI = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get8(ENDPOINT, `form/getpdfformdibyid`, token, id, defaulttypesdi);
        if (!active) return;
        if (getData?.err) {
          setDataForm(INITIAL_DATA_FORM);
          dispatch(setLoading(false));
          dispatch(
            warningErrorAction(
              t(getData.message === "Load failed" ? "Text_ConnectionFailied" : "Text_InvalidCredentials")
            )
          );
          return;
        }
        const decaQrDataUrl = getData?.hasDeCA
          ? await fetchFormDIDecaQr(getData?.id || id, token)
          : '';
        if (!active) return;
        setDataForm({ ...getData, decaQrDataUrl });
        fillEmailFromForm(getData);
        if (getData?.isScanned) {
          setPdfBlob(null);
          const fileName = await resolveDiPdfFilename(ENDPOINT,token,getData.id);
          await fetchFileFromS3(fileName, decaQrDataUrl);
        } else {
          setPdfUrl("");
          setPendingSend(true);
        }
        dispatch(setLoading(false));
      } catch {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };

    // caso id = "0" -> formulario vacío
    if (String(id) === "0") {
      setDataForm(INITIAL_DATA_FORM);
      setFormEMAIL((prev) => ({
        ...prev,
        id: 0,
        defaultStore_id,
        tradename: defaultStore_username,
        useraccount_id,
        username: useraccount_username,
        createdate: new Date(),
        emailto: "gestrescan@gmail.com",
        subjectEmail: "LE REMITO LA INCIDENCIA CON FORMULARIO D.I. Nº: ",
        contentEmail: footeremail,
        resolution: "",
        slatype_id: 1,
        incidenttype_id: defaultIncidenteType.id,
        incidenttype_namees: defaultIncidenteType.namees,
        incidenttype_nameen: defaultIncidenteType.nameen,
        resolution_id: 1,
        formdi_id: 0,
        ownformdi_id: 0,
        numberDI_sheet: "",
        purchase_id: 0,
        ownpurchase_id: 0,
        isfinished: false,
        hasbeenread: false,
        updatedFiles: [],
      }));
      dispatch(setLoading(false));
      return () => {
        active = false;
      };
    }

    // si se abre modal y aún no he cargado dataForm, lo cargo
    if (showModalSentInicidents) {
      fetchFormDI();
    }

    return () => {
      active = false;
    };
  }, [
    showModalSentInicidents,
    id,
    token,
    defaulttypesdi,
    dispatch,
    t,
    defaultStore_id,
    defaultStore_username,
    useraccount_id,
    useraccount_username,
    footeremail,
    defaultIncidenteType.id,
    defaultIncidenteType.namees,
    defaultIncidenteType.nameen,
    roles,
    sendbyemail_form_opt_tras,
    sendbyemail_form_ori_tras,
    sendbyemail_form_aut_tras,
    sendbyemail_form_aut_dest,
    sendbyemail_form_dest_tras,
    sendbyemail_form_rel_trans,
    sendbyemail_form_resp_prod,
  ]);

  /* ------------------------------ Fetch: email list suggestions ------------------------------ */
  useEffect(() => {
    if (!showModalSentInicidents) return;
    const q = (formEMAIL.emailto || "").replace(/[.;\-/\\|]/g, "").trim();
    if (!q) {
      setEmailToSelect(INITIAL_EMAIL_LIST);
      return;
    }
    let active = true;
    const fetchEmails = async () => {
      try {
        const data = await helpHttp().get2(ENDPOINT, `api/getlistemails/`, token, q !== "" ? q : "-1");
        if (!active) return;

        if (data?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          return;
        }
        setEmailToSelect(Array.isArray(data) ? data : INITIAL_EMAIL_LIST);
      } catch {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    fetchEmails();
    return () => {
      active = false;
    };
  }, [showModalSentInicidents, formEMAIL.emailto, token, dispatch, t, i18n.language]);

  /* ------------------------------ Camera stream ------------------------------ */
  useEffect(() => {
    if (!showCameraModal) return;
    let active = true;
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        if (!active) return;
        if (videoRef.current) videoRef.current.srcObject = stream;
      })
      .catch(() => {
        dispatch(warningErrorAction(t("Text_CameraNotAccessible")));
        setShowCameraModal(false);
      });

    return () => {
      active = false;
      stopCameraStream();
    };
  }, [showCameraModal, dispatch, t, stopCameraStream]);

  /* ------------------------------ Escape key behavior ------------------------------ */
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      closeModal();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [closeModal]);

  /* ------------------------------ Auto-attach PDF when generated (not scanned) ------------------------------ */

  useEffect(() => {
    if (!pendingSend) return;
    if (!pdfBlob) return;
    if (!dataForm.numberDI_sheet) return;

    const formattedId =
      dataForm.numberDI_sheet !== undefined && dataForm.numberDI_sheet !== "" && dataForm.numberDI_sheet !== 0
        ? `FORMDI_${dataForm.numberDI_sheet}.pdf`
        : `FORMDI_${String(id).padStart(8, "0")}.pdf`;

    const file = new File([pdfBlob], formattedId, { type: "application/pdf" });

    setFiles((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      const exists = safePrev.some((fo) => (fo?.file || fo)?.name === formattedId);
      return exists ? safePrev : [...safePrev, { file }];
    });

    setPendingSend(false);
  }, [pendingSend, pdfBlob, dataForm.numberDI_sheet, id]);

  /* ------------------------------ Handlers: form fields ------------------------------ */
  const handleChangeEmailField = useCallback((e) => {
    const { name, value } = e.target;
    setFormEMAIL((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleBlurEmailField = useCallback(
    (e) => {
      handleChangeEmailField(e);
      setErrorsEMAIL(validateFormEmail());
    },
    [handleChangeEmailField, validateFormEmail]
  );

  const handleChangeIncidentType = useCallback(
    (event) => {
      const selectedId = event.target.value;
      const selected = (incidenteTypeToSelect || []).find((opt) => String(opt.id) === String(selectedId));

      if (selected) {
        setFormEMAIL((prev) => ({
          ...prev,
          incidenttype_id: selected.id,
          incidenttype_namees: selected.namees,
          incidenttype_nameen: selected.nameen,
        }));
      } else {
        setFormEMAIL((prev) => ({
          ...prev,
          incidenttype_id: defaultIncidenteType.id,
          incidenttype_namees: defaultIncidenteType.namees,
          incidenttype_nameen: defaultIncidenteType.nameen,
        }));
      }
    },
    [incidenteTypeToSelect, defaultIncidenteType]
  );

  /* ------------------------------ Send ------------------------------ */

  const handleConfirmFetchSendInicidents = useCallback(
    async (payload) => {
      closeModal();
      try {
        const res = await helpHttp().post(ENDPOINT, `incidentemail/savesentqueryincident`, token, payload);
        if (res?.status === "OK") {
          dispatch(setLoading(false));
          dispatch(successErrorAction(t("Text_SendData")));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(res?.cause || "Text_IncorrectData")));
        }
      } catch {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    },
    [closeModal, dispatch, t, token]
  );

  const handleSubmitDataEdit = useCallback(async () => {
    const errs = validateFormEmail();
    setErrorsEMAIL(errs);

    if (
      Object.keys(errs).length !== 0 ||
      !defaultStore_id ||
      !useraccount_id ||
      !formEMAIL.emailto ||
      formEMAIL.emailto === "" ||
      !formEMAIL.contentEmail
    ) {
      if (errs.emailto) dispatch(warningErrorAction(t(errs.emailto)));
      else if (errs.contentEmail) dispatch(warningErrorAction(t(errs.contentEmail)));
      else dispatch(warningErrorAction(t("Text_IncorrectData")));
      return;
    }

    dispatch(setLoading(true));

    let updatedFiles = [];
    let updatedFilesImages = [];

    try {
      if (files.length > 0) updatedFiles = await buildUpdatedFiles();
      if (filesImages.length > 0) updatedFilesImages = await buildUpdatedFilesImages();

      const payload = {
        ...formEMAIL,
        updatedFiles: [...updatedFiles, ...updatedFilesImages],
      };

      setFormEMAIL(payload);
      await handleConfirmFetchSendInicidents(payload);
    } catch {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    }
  }, [
    validateFormEmail,
    defaultStore_id,
    useraccount_id,
    formEMAIL,
    dispatch,
    t, 
    buildUpdatedFiles,
    buildUpdatedFilesImages,
    handleConfirmFetchSendInicidents,
    files,
    filesImages,
  ]);

  /* ------------------------------ Camera actions ------------------------------ */
  const handleCapture = useCallback(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;

    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL("image/jpeg");
    handleAddImage([{ data: dataUrl }]);

    setShowCameraModal(false);
    stopCameraStream();
  }, [handleAddImage, stopCameraStream]);

  const handleCancelCamera = useCallback(() => {
    stopCameraStream();
    setShowCameraModal(false);
  }, [stopCameraStream]);

  /* ------------------------------ Render ------------------------------ */
  if (!showModalSentInicidents) {
    return (
      <div>
        {/* Mantiene render de PDF generator fuera del modal, igual que tu versión */}
        {!pdfUrl && !isLoadingData && dataForm.id !== 0 && (
          defaulttypesdi === 1 ? (
            <ReportTemplateFirst dataForm={dataForm} setPdfBlob={setPdfBlob} />
          ) : (
            <ReportTemplateSecond dataForm={dataForm} setPdfBlob={setPdfBlob} />
          )
        )}
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid formgeneral-send-wrapper formdi-incident-form">
        <Box sx={{ bgcolor: "#ffffff", width: "100%" }}>
          <EmailHeader t={t} onSend={handleSubmitDataEdit} onClose={closeModal} />
          <br />
          <div className="formgeneral-card-form">
            <div className="email-header-title2">{t("Text_SENDEMAIL_Data")}</div>
            <hr className="sidebar-divider d-none d-md-block" />
            {/* EMAIL TO */}
            <div className="form-group">
              <div className="row p-2 formdi-incident-inline-field">
                <label className="text-primary" style={{ fontSize: 18 }}>
                  {t("Text_SENDEMAIL_EmailsTo")} :
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div className="inicidents-input-wrapper" style={{ width: "100%", minWidth: 0, maxWidth: "100%" }}>
                  <TextField
                    id="emailto"
                    name="emailto"
                    value={formEMAIL.emailto}
                    onChange={(e) => {
                      const val = (e.target.value || "").toLowerCase();
                      setFormEMAIL((prev) => ({ ...prev, emailto: val }));
                      debouncedSearchEmail(val);
                    }}
                    onKeyDown={handleKeyDownEmail}
                    onBlur={(event) => {
                      if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                        setFilteredEmail([]);
                        setHighlightedIndexEmail(-1);
                      }
                    }}
                    label={errorsEMAIL.emailto ? t(errorsEMAIL.emailto) : t("PlaceHolder_SENDEMAIL_EmailsTo")}
                    placeholder={t("PlaceHolder_SENDEMAIL_EmailsTo")}
                    variant="standard"
                    fullWidth
                    sx={{ minWidth: 0, maxWidth: "100%", "& .MuiInputBase-root": { width: "100%", minWidth: 0 }, "& input": { width: "100% !important", minWidth: 0, boxSizing: "border-box" }, "& label": { maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" } }}
                    inputProps={{ style: { width: "100%", minWidth: 0, boxSizing: "border-box" }, maxLength: 255 }}
                    InputLabelProps={{ style: { fontSize: 18, background: "#FFFFFF" } }}
                  />
                  {filteredEmail.length > 0 && (
                    <div className="inicidents-suggest-dropdown" onMouseDown={(e) => e.preventDefault()}>
                      {filteredEmail.map((store, index) => (
                        <MenuItem
                          key={store.id || `${store.email}-${index}`}
                          onClick={() => handleSelectEmail(store)}
                          style={{
                            cursor: "pointer",
                            padding: "10px 12px",
                            borderBottom: "1px solid #eee",
                            fontSize: 18,
                            backgroundColor: index === highlightedIndexEmail ? "#4e73df" : "transparent",
                            color: index === highlightedIndexEmail ? "white" : "black",
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {store.email}
                        </MenuItem>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* INCIDENT TYPE */}
            <div className="form-group">
              <div className="row p-2 formdi-incident-inline-field">
                <label className="text-primary" style={{ fontSize: 18 }}>
                  {t("Text_SENDEMAIL_InicidentType")} :
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;

                <TextField
                  id="incidenttype_id"
                  name="incidenttype_id"
                  value={
                    formEMAIL.incidenttype_id === undefined ||
                    formEMAIL.incidenttype_id === null ||
                    formEMAIL.incidenttype_id === "" ||
                    formEMAIL.incidenttype_id === "0" ||
                    formEMAIL.incidenttype_id === 0
                      ? defaultIncidenteType.id
                      : formEMAIL.incidenttype_id
                  }
                  inputProps={{ style: { width: i18n.language === "es" ? 639 : 676, fontSize: "18px" } }}
                  InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                  variant="outlined"
                  onChange={handleChangeIncidentType}
                  select
                  SelectProps={{
                    native: false,
                    MenuProps: { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, PaperProps: { sx: { maxHeight: 320, maxWidth: 'calc(100vw - 32px)', borderRadius: 2, '& .MuiMenuItem-root': { whiteSpace: 'normal', fontSize: 16, minHeight: 44, padding: '10px 14px' } } } },
                    value:
                      formEMAIL.incidenttype_id === undefined ||
                      formEMAIL.incidenttype_id === null ||
                      formEMAIL.incidenttype_id === "" ||
                      formEMAIL.incidenttype_id === "0" ||
                      formEMAIL.incidenttype_id === 0
                        ? defaultIncidenteType.id
                        : formEMAIL.incidenttype_id,
                  }}
                >
                  <MenuItem key={0} value="">Selecciona un tipo</MenuItem>
                  {(incidenteTypeToSelect || []).map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {i18n.language === "es" ? opt.namees : opt.nameen}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>

            {/* SUBJECT */}
            <div className="form-group">
              <div className="row p-2 formdi-incident-inline-field">
                <label className="text-primary" style={{ fontSize: 18 }}>
                  {t("Text_SENDEMAIL_Subject")} :
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;

                <TextField
                  id="subjectEmail"
                  name="subjectEmail"
                  value={formEMAIL.subjectEmail || ""}
                  inputProps={{
                    style: { width: i18n.language === "es" ? 893 : 889, fontSize: "18px" },
                    maxLength: 100,
                  }}
                  InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                  label={errorsEMAIL.subjectEmail ? t(errorsEMAIL.subjectEmail) : t("PlaceHolder_SENDEMAIL_Subject")}
                  placeholder={t("PlaceHolder_SENDEMAIL_Subject")}
                  variant="standard"
                  onBlur={handleBlurEmailField}
                  onChange={handleChangeEmailField}
                />
              </div>
            </div>

            {/* CONTENT */}
            <div className="form-group">
              <div className="row p-2">
                <label className="text-primary" style={{ fontSize: 18 }}>
                  {t("Text_SENDEMAIL_Content")} :
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <textarea
                  id="contentEmail"
                  name="contentEmail"
                  className="formdi-incident-content"
                  value={formEMAIL.contentEmail || ""}
                  aria-label={t("Text_SENDEMAIL_Content")}
                  aria-invalid={Boolean(errorsEMAIL.contentEmail)}
                  placeholder={t("PlaceHolder_SENDEMAIL_Content")}
                  onBlur={handleBlurEmailField}
                  onChange={handleChangeEmailField}
                  rows={10}
                />
              </div>
            </div>

            {!isLoadingData ? (
              <div className="form-group">
                <div className="row p-2">
                  <div className="upload-box" style={{ width: "100%" }}>
                    <div className="upload-title">{t("Text_Select_Files")}</div>

                    <DropzoneAreaBase
                      initialFiles={files}
                      fileObjects={files}
                      acceptedFiles={[/* tus tipos aquí */]}
                      maxFileSize={20000000}
                      filesLimit={5}
                      onAdd={handleAddFileContract}
                      onDelete={handleDeleteFileContract}
                      showAlerts={false}
                      getPreviewIcon={handlePreviewIcon}
                      dropzoneText={t("Text_Select_Files")}
                      showPreviews
                      showPreviewsInDropzone={false}
                      useChipsForPreview
                      previewGridProps={{ container: { spacing: 1, direction: "row" } }}
                      previewChipProps={{ classes: { root: "upload-preview-chip" } }}
                      classes={{
                        root: "upload-dropzone-root",
                        icon: "upload-dropzone-icon",
                        text: "upload-dropzone-text",
                      }}
                    />

                    {filesImages.length > 0 && (
                      <div className="preview-thumbnails-wrapper">
                        <div className="preview-thumbnails">
                          {filesImages.map((fileObj, index) => (
                            <div key={index} className="thumbnail-container">
                              <img src={fileObj.data} alt={`preview-${index}`} className="thumbnail-image" />
                              <button
                                type="button"
                                onClick={() => handleDeleteImage(fileObj)}
                                className="thumbnail-delete-btn"
                                title={t("Text_Delete")}
                              >
                                &times;
                              </button>
                              <button
                                type="button"
                                onClick={() => setPreviewImage(fileObj.data)}
                                className="thumbnail-zoom-btn"
                                title={t("Text_Zoom")}
                              >
                                🔍
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="audio-recorder-card">
                      <div className="audio-recorder-controls">
                        <img src={image1} alt="Camera Icon" style={{ width: 50, height: 50 }} />
                        <button type="button" className="btn-blue-outline" onClick={() => setShowCameraModal(true)}>
                          {t("Button_TakePhoto")}
                        </button>

                        <AudioRecorder
                          className="audio-recorder"
                          onAudioRecorded={(file) => {
                            if (file) {
                              setFiles((prev) => [...prev, { file, data: URL.createObjectURL(file) }]);
                            } else {
                              setFiles((prev) => prev.filter((f) => !(f?.file?.type || "").startsWith("audio/")));
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="incident-pdf-preview">{pdfViewer}</div>
                  </div>
                </div>
              </div>
            ) : (
              <LoadingNews />
            )}
          </div>
        </Box>
        <PreviewModal t={t} previewImage={previewImage} onClose={() => setPreviewImage(null)} />
        <CameraModal
          t={t}
          open={showCameraModal}
          videoRef={videoRef}
          canvasRef={canvasRef}
          onCapture={handleCapture}
          onCancel={handleCancelCamera}
        />
      </div>

      {/* PDF generator (si no hay pdfUrl, genera blob y se auto adjunta) */}
      {shouldGeneratePdf && (
        defaulttypesdi === 1 ? (
          <ReportTemplateFirst dataForm={dataForm} setPdfBlob={setPdfBlob} />
        ) : (
          <ReportTemplateSecond dataForm={dataForm} setPdfBlob={setPdfBlob} />
        )
      )}

      <br />
    </div>
  );
};

SendEMAILFormDIToSystem.propTypes = {
  id: PropTypes.any,
  showModalSentInicidents: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string,
};

export default SendEMAILFormDIToSystem;
